import { clsx } from 'clsx';

import type { OrderSortActivities } from '../types';

type OrderSortIconProps = {
  activity: OrderSortActivities;
};

export const OrderSortIcon = ({ activity }: OrderSortIconProps) => {
  const isAscending = activity === 'asc';

  const isDescending = activity === 'desc';

  return (
    <div className='flex flex-col gap-1 w-4 h-4'>
      <div
        className={clsx('h-0.5 rounded-sm bg-blue-400 duration-75 ease-in-out', {
          'w-0': !activity,
          'w-5/12': isAscending,
          'w-full': isDescending,
        })}
      ></div>
      <div
        className={clsx('h-0.5 rounded-sm bg-blue-400 duration-75 ease-in-out', {
          'w-0': !activity,
          'w-9/12': isAscending || isDescending,
        })}
      ></div>
      <div
        className={clsx('h-0.5 rounded-sm bg-blue-400 duration-75 ease-in-out', {
          'w-0': !activity,
          'w-full': isAscending,
          'w-5/12': isDescending,
        })}
      ></div>
    </div>
  );
};
